<template>
  <v-container>
    <template v-if="loading">
      <v-row justify="start" align-content="center" class="mt-10">
        <img src="../../assets/loading.gif">
      </v-row>
    </template>
    <template v-else>
      <v-card-title class="pb-3">
        <p class="font-weight-bold">ユーザーPR設定</p>
      </v-card-title>
      <v-card-text class="pt-0">
        <ValidationObserver ref="observer" v-slot="{ invalid }">
          <v-form ref="form" v-on:submit.prevent="updateAppeal">
            <v-row>
              <v-col cols="12" md="8">
                <span class="font-weight-bold">性格：</span>
                  <v-row cols="10" class="pt-0" v-for="(user_character, index) in userUpdatePr.user_characters" v-bind:key="index">
                    <v-col>
                      <ValidationProvider name="性格" rules="required" v-slot="{ errors }">
                        <v-select
                          class="pt-8"
                          v-model="userUpdatePr.user_characters[index].character_id"
                          :items="characterTypes"
                          item-text="name"
                          item-value="character_id"
                          @change="UpdateRadarChart"
                          :error-messages="errors[index]"
                          dense
                          solo
                        ></v-select>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="2">
                      <ValidationProvider name="性格スコア" rules="max_value:5" v-slot="{ errors }">
                        <v-select
                          class="pt-8 character-score"
                          v-model="userUpdatePr.user_characters[index].score"
                          :items="count"
                          dense
                          solo
                          style="min-width: 64px;"
                          :error-messages="errors[index]"
                          @change="UpdateRadarChart"
                        ></v-select>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="8">
                <RadarChart v-if="isRadarChart" :chartData="userUpdatePr.user_characters" :characterTypes="characterTypes"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="8">
                <span class="font-weight-bold">得意とするスキル：</span>
                <v-row v-for="(user_language, index) in userUpdatePr.user_languages" v-bind:key="index">
                  <v-col cols="9" class="pt-0">
                    <ValidationProvider name="スキル" rules="required" v-slot="{ errors }">
                      <v-select
                        class="pt-8"
                        v-model="userUpdatePr.user_languages[index].technology_id"
                        :items="languageTypes"
                        item-text="name"
                        item-value="technology_id"
                        dense
                        solo
                        @change="UpdateBarChart"
                        :error-messages="errors"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="3" class="pt-0">
                    <ValidationProvider name="スキルスコア" rules="max_value:100" v-slot="{ errors }">
                      <v-text-field
                        class="pt-8 language-score"
                        v-model="userUpdatePr.user_languages[index].score"
                        :items="user_language.score"
                        dense
                        solo
                        suffix="/ 100%"
                        style="min-width: 104px;"
                        :error-messages="errors"
                        @change="UpdateBarChart"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="8">
                <BarChart v-if="isBarChart" :chartData="userUpdatePr.user_languages" :languageTypes="languageTypes" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="8">
                  <span class="font-weight-bold">得意とするツール：</span>
                  <v-row>
                    <v-col cols="10" class="pt-8">
                        <v-progress-linear
                          height="36"
                          color="#FF7171"
                          class="meter"
                        >
                          <ValidationProvider name="スキルスコア合計" rules="value:100" v-slot="{ errors }">
                              <strong :error-messages="errors">{{ Math.ceil(knowledge) }}%</strong>
                          </ValidationProvider>
                        </v-progress-linear>
                    </v-col>
                  </v-row>
                  <v-row v-for="(user_tool, index) in userUpdatePr.user_tools" v-bind:key="index">
                    <v-col cols="8" class="pt-0">
                      <ValidationProvider name="ツール：" rules="required" v-slot="{ errors }">
                      <v-select
                        class="pt-8"
                        v-model="userUpdatePr.user_tools[index].technology_id"
                        :items="toolTypes"
                        item-text="name"
                        item-value="technology_id"
                        dense
                        solo
                        @change="UpdatePieChart"
                        :error-messages="errors"
                      ></v-select>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="2" class="pt-0">
                      <ValidationProvider name="スキルスコア" rules="numeric|max_value:100|min_value:1" v-slot="{ errors }">
                      <v-text-field
                        class="pt-8"
                        v-model="userUpdatePr.user_tools[index].score"
                        :items="user_tool.score"
                        dense
                        solo
                        suffix="％"
                        style="min-width: 74px;"
                        :error-messages="errors"
                        @change="UpdatePieChart"
                      ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="2" class="pt-0">
                      <v-btn
                        color="red"
                        class="font-weight-bold ml-4 mt-8 button-shadow"
                        width="30%"
                        text
                        outlined
                        style="width: 74px; height: 38px;"
                        @click="deleteInput(index)"
                      >削除</v-btn>
                    </v-col>
                  </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="8" class="pt-0">
                <v-row justify="center">
                  <v-btn
                    color="green"
                    class="font-weight-bold button-shadow"
                    width="30%"
                    text
                    outlined
                    @click="addInput()"
                  >追加</v-btn>
                  </v-row>
                </v-col>
              <v-col cols="12" md="8">
                <PieChart v-if="isPieChart" :chartData="userUpdatePr.user_tools" :toolTypes="toolTypes" />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12" md="8">
                <v-btn
                  color="#5E00BC"
                  class="button-shadow ma-4 font-weight-bold"
                  width="30%"
                  type="submit"
                  :disabled="invalid"
                >変更する</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-card-text>
    </template>
  </v-container>
</template>
<script>
import RadarChart from '../molecules/RadarChart.vue';
import BarChart from '../molecules/BarChart.vue';
import PieChart from '../molecules/PieChart.vue';

export default {
  name: 'UserEditAccount',
  components: {
    RadarChart,
    BarChart,
    PieChart,
  },
  data() {
    return {
      loading: true,
      // チャートのリロードに使用
      isRadarChart: true,
      isBarChart: true,
      isPieChart: true,
      inputValue: "",
      knowledge: 0,
      selectedItem: {
        selectedValue: 'uiframework', showLabel: 'Vuetify'
      },
      userUpdatePr: {
        // ユーザー性格は初期値:5で作成
        user_characters: [
          {
            character_id: 1,
            score: 5
          },
          {
            character_id: 2,
            score: 5
          },
          {
            character_id: 3,
            score: 5
          },
          {
            character_id: 4,
            score: 5
          },
          {
            character_id: 5,
            score: 5
          }
        ],
        user_languages: [
          {
            technology_id: 1,
            score: 100
          },
          {
            technology_id: 2,
            score: 100
          },
          {
            technology_id: 3,
            score: 100
          },
          {
            technology_id: 4,
            score: 100
          },
          {
            technology_id: 5,
            score: 100
          },
          {
            technology_id: 6,
            score: 100
          }
        ],
        user_tools: []
      },
      preview: null,
      old_password: '',
      new_password: '',
      new_password_confirmation: '',
      count: [1,2,3,4,5],
      characterTypes: [],
      languageTypes: [],
      toolTypes: [],
    };
  },
  computed: {
    getUserCode() {
      return this.$store.getters['auth/isUserCode']
    },
  },
  methods: {
    updateAppeal() {
      this.$store.dispatch('userinfo/updateAppeal', this.userUpdatePr)
      .then(() => {
        location.reload();
      })
      .catch(() => {
      });
    },
    UpdateRadarChart() {
      this.isRadarChart = false;
      this.$nextTick(() => (this.isRadarChart = true));
    },
    UpdateBarChart() {
      this.isBarChart = false;
      this.$nextTick(() => (this.isBarChart = true));
    },
    UpdatePieChart() {
      this.UpdatetKnowledge();
      this.isPieChart = false;
      this.$nextTick(() => (this.isPieChart = true));
    },
    UpdatetKnowledge() {
      this.knowledge = 0;
      const total = this.userUpdatePr.user_tools.reduce((sum, i) => Number(sum) + Number(i.score), 0);
      this.knowledge = total;
    },
    getUserInfo() {
      this.$store.dispatch('userinfo/get', this.getUserCode)
          .then(() => {
            this.user = this.$store.getters['userinfo/getUser']
            this.loading = false
          });
    },
    addInput() {
      this.userUpdatePr.user_tools.push({ technology_id: 16, score: 0 });
    },
    deleteInput(index) {
      this.userUpdatePr.user_tools.splice(index, 1);
      this.UpdatetKnowledge();
      this.UpdatePieChart();
    },
  },
  created() {
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/characters')
      .then(response => {
        this.characterTypes = response.data;
      });
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/technologies?category=lang')
      .then(response => {
        this.languageTypes = response.data;
      });
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/technologies?category=tool')
      .then(response => {
        this.toolTypes = response.data;
      });
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/user/appeal/' + this.getUserCode)
      .then(response => {
        // 取得できた場合は上書き
        if (response.data.user_characters.length > 0) {
          this.userUpdatePr.user_characters = response.data.user_characters;
          this.UpdateRadarChart();
        }
        if (response.data.user_languages.length > 0) {
          this.userUpdatePr.user_languages = response.data.user_languages;
          this.UpdateBarChart();
        }
        if (response.data.user_tools.length > 0) {
          this.userUpdatePr.user_tools = response.data.user_tools;
          this.UpdatePieChart();
        }
      });
      setTimeout(function() {
        this.loading = false;
      }.bind(this), 2000);
  }
}
</script>
<style scoped>
.meter {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  border-bottom-left-radius: 24px;
}
.character-score {
    width: 92px;
}
.language-score {
    width: 112px;
}
</style>